import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import StationeryDispatchNewEditForm from '../stationery-dispatch-new-edit-form';

export default function StationeryDispatchCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new dispatch"
        links={[
          {
            name: 'Dispatch',
            href: paths.dashboard.stationeryDispatch.root,
          },
          { name: 'Create a new dispatch' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <StationeryDispatchNewEditForm />
    </Container>
  );
}
